export function format (date, fmt) {
  let dateStr = new Date(date)
  let o = {
    'M+': dateStr.getMonth() + 1,
    'D+': dateStr.getDate(),
    'h+': dateStr.getHours(),
    'm+': dateStr.getMinutes(),
    's+': dateStr.getSeconds(),
    'q+': Math.floor((dateStr.getMonth() + 3) / 3),
    S: dateStr.getMilliseconds()
  }
  if (/(Y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (dateStr.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

export function formatDuration (s) {
  if (s < 60) {
    return s + '秒'
  } else if (s < 60 * 60) {
    return parseInt(s / 60) + '分' + (s % 60) + '秒'
  } else if (s < 60 * 60 * 60) {
    var seconds = s % (60 * 60)
    return parseInt(s / 60 / 60) + '小时' + parseInt(seconds / 60) + '分' + (seconds % 60) + '秒'
  } else {
    var seconds = s % (60 * 60)
    return parseInt(s / 60 / 60) + '小时' + parseInt(seconds / 60) + '分' + (seconds % 60) + '秒'
  }
}

export function moneyToChina (n) {
  var unit = '千百拾亿千百拾万千百拾元角分',
    str = ''
  n += '00'
  var p = n.indexOf('.')
  if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2)
  unit = unit.substr(unit.length - n.length)
  for (var i = 0; i < n.length; i++)
    str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i)
  return str
    .replace(/零(千|百|拾|角)/g, '零')
    .replace(/(零)+/g, '零')
    .replace(/零(万|亿|元)/g, '$1')
    .replace(/(亿)万|壹(拾)/g, '$1$2')
    .replace(/^元零?|零分/g, '')
    .replace(/元$/g, '元整')
}

export function formatMoney (money) {
  if (money && money != null) {
    money = String(money)
    var left = money.split('.')[0],
      right = money.split('.')[1]
    right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00'
    var temp = left
      .split('')
      .reverse()
      .join('')
      .match(/(\d{1,3})/g)
    return (
      (Number(money) < 0 ? '-' : '') +
      temp
        .join(',')
        .split('')
        .reverse()
        .join('') +
      right
    )
  } else {
    return '0.00'
  }
}

export function formatUnit (value, num) {
  let n = 3
  if (num) {
    n = num
  }
  if (value && value != null) {
    value = String(value)
    let valArr = value.split('.')
    let left = valArr[0]
    let right = valArr[1] ? valArr[1].substring(0, n) : undefined
    let s = right ? right : ''
    if (right) {
      for (var i = 0; i < n - s.length; i++) {
        right += '0'
      }
    }
    let str = ''
    for (var i = 0; i < n; i++) {
      str += '0'
    }
    return left + '.' + (right ? right : str)
  } else {
    let str = ''
    for (var i = 0; i < n; i++) {
      str += '0'
    }
    return '0.' + str
  }
}
export function formatDate (date, fmt) {
  let dateStr = new Date(date)
  let o = {
    'M+': dateStr.getMonth() + 1,
    'D+': dateStr.getDate(),
    'h+': dateStr.getHours(),
    'm+': dateStr.getMinutes(),
    's+': dateStr.getSeconds(),
    'q+': Math.floor((dateStr.getMonth() + 3) / 3),
    S: dateStr.getMilliseconds()
  }
  if (/(Y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (dateStr.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}
/* 
 * 参数说明：
 * number：要格式化的数字
 * decimals：保留几位小数
 * thousands_sep：千分位符号
 * */
export function formatNumber (number, decimals, thousands_sep) {
  number = (number + '').replace(/[^0-9±Ee.]/g, '')
  let n = !isFinite(+number) ? 0 : +number
  let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)

  let sep = thousands_sep
  let dec = '.'
  let s = ''
  let toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec)
    return '' + Math.round(n * k) / k
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  if (sep) {
    let re = /(-?\d+)(\d{3})/
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, '$1' + sep + '$2')
    }
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }

  return s.join(dec)
}
// 阿拉伯数字转换为汉字
export function convertToChineseNumeral (num) {
  if (num == 10) {
    return '十'
  } else if (num == 1) {
    return '一'
  }
  const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const units = ['', '十', '百', '千', '万'];
  let result = '';
  let numStr = num.toString();
  for (let i = 0; i < numStr.length; i++) {
    let digit = parseInt(numStr.charAt(i));
    let unit = units[numStr.length - i - 1];
    if (digit === 0) {
      // 当前数字为0时不需要输出汉字，但需要考虑上一个数字是否为0，避免出现连续的零
      if (result.charAt(result.length - 1) !== '零') {
        result += '零';
      }
    } else {
      result += digits[digit] + unit;
    }
  }
  // 对于一些特殊的数字，如10、100等，需要在最前面加上“一”
  if (result.charAt(0) === '一') {
    result = result.substr(1, result.length);
  } else if (result.charAt(0) === '百') {
    result = '一' + result;
  } else if (result.charAt(0) === '千') {
    result = '一' + result;
  }
  return result;
}
export function transState (str, arr, code, value) {
  let s = str;
  let c = code || 'code';
  let l = value || 'value'
  arr.map(v => {
    if (v[c] == str) {
      s = v[l]
    }
  })
  return s
}
// 减精度
export function subFloalToint (arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}
/**
 ** 加法函数，用来得到精确的加法结果
 ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 ** 调用：add(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
export function add (arg1, arg2) {
  if (isUndef(arg1) || isUndef(arg2)) return 0

  let r1, r2, m, c
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  c = Math.abs(r1 - r2)
  m = Math.pow(10, Math.max(r1, r2))
  if (c > 0) {
    var cm = Math.pow(10, c)
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''))
      arg2 = Number(arg2.toString().replace('.', '')) * cm
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm
      arg2 = Number(arg2.toString().replace('.', ''))
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''))
    arg2 = Number(arg2.toString().replace('.', ''))
  }
  return (arg1 + arg2) / m
}
export function isUndef (v) {
  return v === undefined || v === null
}


// WEBPACK FOOTER //
// ./src/server/utils.js